import { useTranslation } from 'react-i18next';
import { Loader } from 'components/Loader';
import { Heading } from 'components/Typography';
import { ScreenerContext, withScreenerMachineState } from 'domains/signup/screener/context/screenerContext';
import { useEffectOnce } from 'react-use';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { identifyScreenerLDUser } from 'domains/signupDirect/misc/launchDarklyTracking';
import { getYearsOfAge } from 'utils/date';

const LoadingScreener: React.FC = () => {
  const { t } = useTranslation();

  const ctx = ScreenerContext.useSelector(actor => actor.context);
  const LDClient = useLDClient();
  useEffectOnce(() => {
    if (LDClient) {
      identifyScreenerLDUser(LDClient, {
        age: ctx.dob ? getYearsOfAge(ctx.dob) : undefined,
        target: ctx.target,
      });
    }
  });
  return (
    <>
      <Heading level="h2" className="mb-64">
        {t('screener.steps.loadingScreener.title')}
      </Heading>
      <Loader className="flex justify-center p-24 text-primary-500" />
    </>
  );
};

export const ScreenerLoadingScreener = withScreenerMachineState(LoadingScreener, 'loadingScreener');
